module.exports = __webpack_public_path__ + "static/image/service/pc/shopping_live@3x.jpg?c0a96953";